import { computed, reactive } from 'vue'
import { camelizeKeys } from 'humps'
import { useLoader } from '../useLoader'
import { useError } from '../useError'
import { useYearSelector } from '@/services/useYearSelector'
import axios from '@/axios'

const topState = reactive({
  notificationTop: [],
})

export const useNotifications = () => {
  const { toggleShowLoader } = useLoader()
  const { toggleShowError } = useError()

  /**
   * お知らせリストを取得する
   *
   * @param {number} year 取得する年度
   */
  const getNotifications = async (year = new Date().getFullYear()) => {
    try {
      toggleShowLoader(true)
      let res = await axios.get(`/notifications?year=${year}`)
      res = camelizeKeys(res)
      topState.notificationTop = Array.from(res.data.notifications)

      toggleShowLoader(false)
    } catch (e) {
      toggleShowError(true)
      toggleShowLoader(false)
    }
  }

  /**
   * レスポンスが正常な場合お知らせリストを取得する
   *
   * @param {object} response
   * @returns void
   */
  const getNotificationsAfterResponse = async response => {
    if (response?.data?.code !== 0) {
      return
    }
    const { currentYear } = useYearSelector()
    await getNotifications(currentYear.value)
  }

  return {
    notificationTop: computed(() => topState.notificationTop),
    getNotifications,
    getNotificationsAfterResponse,
  }
}
